import { useEffect, useRef, useState } from "react";
import Btn from "./ui/Btn.jsx";
import Eyebrow from "./ui/Eyebrow.jsx";
import { signOut, userEmail, userInitials } from "../lib/auth.js";

export default function UserMenu({ session, size = 30 }) {
  const [open, setOpen] = useState(false);
  const [signingOut, setSigningOut] = useState(false);
  const btnRef = useRef(null);
  const popRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (popRef.current && popRef.current.contains(e.target)) return;
      if (btnRef.current && btnRef.current.contains(e.target)) return;
      setOpen(false);
    };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const email = userEmail(session);
  const initials = userInitials(session);
  const name = session?.user?.user_metadata?.name || session?.user?.user_metadata?.full_name || "";

  const handleSignOut = async () => {
    setSigningOut(true);
    try { await signOut(); } finally { setSigningOut(false); setOpen(false); }
  };

  return (
    <div style={{ position: "relative", display: "inline-flex" }}>
      <button
        ref={btnRef}
        type="button"
        onClick={() => setOpen(v => !v)}
        title={email}
        style={{
          width: size, height: size, borderRadius: "50%",
          background: "var(--paper-2)", border: "1px solid var(--line)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 11, fontWeight: 600, color: "var(--ink-2)",
          fontFamily: "var(--ui)",
          cursor: "pointer",
          padding: 0,
        }}
      >
        {initials}
      </button>

      {open && (
        <div
          ref={popRef}
          style={{
            position: "absolute",
            right: 0,
            top: size + 8,
            zIndex: 500,
            background: "var(--paper-0)",
            border: "1px solid var(--line-2)",
            borderRadius: 12,
            padding: "14px 16px",
            width: 260,
            boxShadow: "0 12px 36px rgba(34,28,20,0.14)",
            fontFamily: "var(--ui)",
          }}
        >
          <Eyebrow style={{ marginBottom: 8 }}>Signed in</Eyebrow>
          {name && (
            <div style={{
              fontFamily: "var(--display)", fontSize: 16, color: "var(--ink)",
              letterSpacing: -0.1, marginBottom: 2,
            }}>{name}</div>
          )}
          <div style={{
            fontSize: 12, color: "var(--ink-3)", wordBreak: "break-all",
            marginBottom: 14,
          }}>{email}</div>
          <Btn variant="ghost" size="sm" onClick={handleSignOut} disabled={signingOut}
               style={{ width: "100%" }}>
            {signingOut ? "Signing out…" : "Sign out"}
          </Btn>
        </div>
      )}
    </div>
  );
}
